/**
 * Shared recharts palette for J&J-branded charts. Hex values are taken
 * verbatim from public/brand/theme.json tokens — never invented.
 *
 * Colour roles:
 * - EMPHASIS (J&J red #eb1700) — reserved for a *single* emphasized series or
 *   the max bar in a single-series emphasis chart. Never used for categorical
 *   breakdowns (a donut has no single "winning" slice).
 * - ACCENTS — the categorical ramp for donut slices and multi-series charts.
 *   Mid-tone brand accents come first (distinguishable on a white card under a
 *   projector), then the lighter/darker shades of the same tokens. Sourced from
 *   theme.json `accents` verbatim.
 * - INK + SUPPORTING (warm grays) — INK anchors the primary series; the warm
 *   grays de-emphasize non-max bars in a single-series emphasis chart.
 *
 * Hoisted out of chart-card.tsx so both the analysis charts and the demo-voting
 * histogram share one source of truth (and so chart-card stays a component-only
 * module for Vite Fast Refresh).
 */

export const EMPHASIS = "#eb1700"; // J&J red — single emphasis series/bar only

/**
 * Categorical ramp for donut slices and multi-series charts. Mid-tone accents
 * first so a 2–4 category chart is instantly distinguishable, then the lighter
 * and darker shades of the same tokens for larger breakdowns. All verbatim from
 * theme.json `accents`.
 */
export const ACCENTS = [
  "#0F68B2", // blue — mid
  "#328714", // green — mid
  "#8C3BBB", // violet — mid
  "#FF6017", // orange
  "#69D0FF", // blue — light
  "#53CE76", // green — light
  "#B19BEB", // violet — light
  "#004685", // blue — dark
  "#3B5A0D", // green — dark
  "#541980", // violet — dark
];

export const SUPPORTING = ["#81766f", "#a39992", "#564c47", "#d5cfc9"]; // warm grays
export const GRID = "#e8e6e3"; // warm-gray-03
export const AXIS = "#81766f"; // warm-gray-07

export const AXIS_TICK = { fontSize: 11, fill: AXIS };
export const TOOLTIP_STYLE = {
  fontSize: 12,
  borderRadius: 6,
  border: `1px solid ${GRID}`,
  boxShadow: "none",
};
